import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/about";
import { aboutJsonLd, personJsonLd } from "@/pages/about.seo";

import { brand } from "@/config/brand";
const SITE_URL = brand.url;
const OG_IMAGE = `${SITE_URL}/__l5e/assets-v1/aabeccab-688e-44b7-96b1-aaf70d6a2a8d/social-share-cover.png`;
const OG_ALT = "Digitally Baffled LTD — UK Digital Transformation Consultancy";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About Us — Founded by Morgan Antell | Digitally Baffled" },
      {
        name: "description",
        content:
          "UK digital consultancy founded by Morgan Antell in Ringwood, Hampshire. Web design, SEO, AEO & GEO, PPC and ongoing support — in plain English, no jargon.",
      },
      { property: "og:site_name", content: "Digitally Baffled" },
      { property: "og:title", content: "About Digitally Baffled LTD — Founded by Morgan Antell" },
      {
        property: "og:description",
        content:
          "We exist because small businesses deserve better than confusing tech, overpriced agencies, and jargon. Learn the story behind Digitally Baffled.",
      },
      { property: "og:url", content: `${SITE_URL}/about` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:secure_url", content: OG_IMAGE },
      { property: "og:image:type", content: "image/png" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: OG_ALT },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:site", content: "@digitallybaffld" },
      { name: "twitter:creator", content: "@digitallybaffld" },
      { name: "twitter:title", content: "About Digitally Baffled LTD — Founded by Morgan Antell" },
      {
        name: "twitter:description",
        content:
          "We exist because small businesses deserve better than confusing tech, overpriced agencies, and jargon. Learn the story behind Digitally Baffled.",
      },
      { name: "twitter:image", content: OG_IMAGE },
      { name: "twitter:image:alt", content: OG_ALT },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/about` }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(aboutJsonLd) },
      { type: "application/ld+json", children: JSON.stringify(personJsonLd) },
    ],
  }),
  component: Page,
});
